import { defineMessages } from "react-intl";
export default defineMessages({
    chooseWorkTypes: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.choose-work-types",
        defaultMessage: "What types of work do you need?",
        description: "Choose the work types that your team will be working on"
    },
    workTypesDescription: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.work-types-description",
        defaultMessage: "These form the building blocks of your project.",
        description: "Description of work types"
    },
    addMoreWorkTypesLater: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.add-more-work-types-later",
        defaultMessage: "Don’t worry, you can change these later.",
        description:
            "Message to inform user that they can add more work types later"
    },
    step: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.step",
        defaultMessage: "Step 2 of 3",
        description: "Step in the onboarding flow"
    },
    nextButtonCta: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.next-button-cta",
        defaultMessage: "Next",
        description: "CTA for the next button"
    },
    issueTypeValidation: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.issue-type-validation",
        defaultMessage: "Select at least one work type.",
        description: "Validation message for issue types"
    },
    // JFIND-1968 variation
    workTypesDescriptionVariation: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.work-types-description-variation",
        defaultMessage: "These form the building blocks of your space.",
        description: "Description of work types"
    },
    // cfind4831ProductOverlayModalVisualUpdates visual update
    workTypesDescriptionVisualUpdate: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.work-types-description-visual-update",
        defaultMessage: "These form the building blocks of your space.",
        description: "Description of work types for visual update"
    }
});
